// extracted by mini-css-extract-plugin
export default {"NotificationHubTrigger":"NotificationHubTrigger_NotificationHubTrigger__ehCxq","NotificationIcon":"NotificationHubTrigger_NotificationIcon__i63M0"};